import { buildApiUrl, ADMIN_ENDPOINTS } from '../../configs/api.js'

export default {
  url(payload) {
    const { userId } = payload || {}
    // S'il y a un userId, on pourrait appeler /list/user/{userId} selon la doc, mais ici c'est admin
    return buildApiUrl(ADMIN_ENDPOINTS.SUPPORT_TICKETS_LIST_ALL || '/support-ticket/list/all', {})
  },

  parse(raw = {}, payload = {}) {
    if (raw.statusCode !== 200 && raw.statusCode !== 201) {
      return {
        statusCode: raw?.statusCode || 400,
        message: raw?.message || 'Error',
        data: null,
      }
    }

    const res = raw.data || {}
    const tickets = Array.isArray(res) ? res : (Array.isArray(res.data) ? res.data : [])

    let data = tickets.map(el => {
      // Recherche des infos utilisateur dans les messages s'ils ne sont pas à la racine
      const userMessage = el.messages?.find(m => m.senderId === el.userId) || el.messages?.[0] || {}

      return {
        ...el,
        id: el.id,
        userId: el.userId,
        title: el.subject || el.title,
        description: el.messages?.[0]?.text || el.message || el.description || '',
        date: el.createdAt,
        status: el.status || 'open',
        priority: el.priority || 'normal',
        customerName: el.senderName || el.userName || el.customerName || userMessage.senderName || 'Inconnu',
        customerId: el.userId,
        userRole: el.senderRole || el.userRole || el.userType || userMessage.senderRole || 'customer',
        createdAt: el.createdAt,
        resolvedAt: el.resolvedAt,
        updatedAt: el.updatedAt,
        lastMessageAt: el.lastMessageAt,
        lastMessageBy: el.lastMessageBy,
        messages: el.messages || []
      }
    })

    // === Recherche textuelle ===
    if (payload?.search) {
      const searchLower = payload.search.toString().toLowerCase()
      data = data.filter(el => {
        if (el?.id?.toLowerCase().includes(searchLower)) return true
        if (el?.title?.toLowerCase().includes(searchLower)) return true
        if (el?.customerName?.toLowerCase().includes(searchLower)) return true
        if (el?.customerId?.toLowerCase().includes(searchLower)) return true
        if (el?.status?.toLowerCase().includes(searchLower)) return true
        return false
      })
    }

    // === Tri dynamique selon payload.sortKey et sortOrder ===
    const { sortKey, sortOrder } = payload || {}
    if (sortKey) {
      const order = sortOrder === 'desc' ? -1 : 1
      data = [...data].sort((a, b) => {
        const valA = a?.[sortKey]
        const valB = b?.[sortKey]
        if (typeof valA === 'string' && typeof valB === 'string') {
          return valA.localeCompare(valB) * order
        }
        if (typeof valA === 'number' && typeof valB === 'number') {
          return (valA - valB) * order
        }
        return 0
      })
    }

    const { page = 0, limit = 10000 } = payload || {}
    const paginated = data.slice(page * limit, (page + 1) * limit)

    return {
      statusCode: 200,
      message: 'Ok',
      data: {
        total: res.total || data.length,
        result: res.total !== undefined ? data : paginated,
      },
    }
  },
}
